import React, { useEffect, useState } from "react"
import { defineMessages, injectIntl } from "react-intl"
import Select from "react-select"
import PaymentTypeService from "../../state/payment-type/PaymentTypeService"
import { isError } from "../../state/helpers/Error"
import {Intl} from "../../state/helpers/IntlProps"

const messages = defineMessages({
    "select_payment_method_label": {
        id: "invoice.receive_payment.select_payment_method_label",
        defaultMessage: "Select payment method",
    },
    "credit_card_label": {
        id: "invoice.receive_payment.type_credit_card_label",
        defaultMessage: "Credit card",
    },
    "check_label": {
        id: "invoice.receive_payment.check_label",
        defaultMessage: "Check",
    },
    "cash_label": {
        id: "invoice.receive_payment.cash_label",
        defaultMessage: "Cash",
    },
    "bank_transfer_label": {
        id: "invoice.receive_payment.bank_transfer_label",
        defaultMessage: "Bank transfer",
    },
    "credit_label": {
        id: "invoice.receive_payment.generic_credit_label",
        defaultMessage: "Credit",
    },
})


type Props = {
    intl: Intl
    multi?: boolean
    disabled?: boolean
    clearable?: boolean
    onChange: (selectedPaymentTypeIds: string[], selectedPaymentTypeLabels: string) => void
    selectedPaymentTypeIds: string[]
}

const GenericPaymentTypeSelectComponent = (props: Props) => {
    const [paymentTypeOptions, setPaymentTypeOptions] = useState<object[]>([])
    const [selectedPaymentTypeOptions, setSelectedPaymentTypeOptions] = useState<object | object[]>([])

    useEffect(() => {
        PaymentTypeService.GetAllPaymentTypes().then(res => {
            if (!isError(res)) {
                const enabledPaymentTypes = res.filter(paymentType => paymentType.getStatus() === "enabled")

                let options = [
                    {
                        value: "credit-card",
                        label: props.intl.formatMessage(messages["credit_card_label"]),
                    },
                    {
                        value: "check",
                        label: props.intl.formatMessage(messages["check_label"]),
                    },
                    {
                        value: "bank-transfer",
                        label: props.intl.formatMessage(messages["bank_transfer_label"]),
                    },
                    {
                        value: "cash",
                        label: props.intl.formatMessage(messages["cash_label"]),
                    },
                    {
                        value: "credit",
                        label: props.intl.formatMessage(messages["credit_label"]),
                    },
                ]

                options = options.concat(
                    enabledPaymentTypes.map(customPaymentType => {
                        return {
                            value: customPaymentType.getId(),
                            label: customPaymentType.getName(),
                        }
                    })
                )

                setPaymentTypeOptions(options)

                const selectedOptions = options.filter(o => props.selectedPaymentTypeIds.includes(o.value))
                setSelectedPaymentTypeOptions(selectedOptions)
            }
        })

    }, [])


    const handleChange = (selectedOptions) => {
        setSelectedPaymentTypeOptions(selectedOptions)
        const selectedPaymentTypeIds = Array.isArray(selectedOptions) ?
            selectedOptions.map(o => o.value) : [selectedOptions.value]

        const selectedPaymentTypeLabels = Array.isArray(selectedOptions) ?
            selectedOptions.map(option => option.label).join(", ") : selectedOptions.label

        props.onChange(selectedPaymentTypeIds, selectedPaymentTypeLabels)
    }

    return <Select
        name={"paymentType"}
        value={selectedPaymentTypeOptions}
        onChange={handleChange}
        options={paymentTypeOptions}
        clearable={props.clearable}
        searchable={false}
        disabled={props.disabled}
        multi={props.multi}
    />
}


export default injectIntl(GenericPaymentTypeSelectComponent)


// WEBPACK FOOTER //
// ./src/payment-type/form/GenericPaymentTypeSelectComponent.tsx